// import React, { useEffect, useState } from 'react';
// import { toast } from 'react-toastify';
// import axios from 'axios';
// import ClipLoader from 'react-spinners/ClipLoader';
// import './UpdateCourse.css';
// import Modal from "react-modal";
// import { addLessonToSection, addSectionToCourse, submitCourseForApproval, deleteLesson, deleteSection, COURSES_URL } from '../../Services/Services';

// const UpdateCourse = ({ selectedCourse, closeModal, fetchCourses }) => {
//     const [loading, setLoading] = useState(false);
//     const [title, setTitle] = useState('');
//     const [description, setDescription] = useState('');
//     const [price, setPrice] = useState('');
//     const [imagePreview, setImagePreview] = useState('');
//     const [category, setCategory] = useState('');
//     const [subcategory, setSubcategory] = useState('');
//     const [level, setLevel] = useState('');
//     const [language, setLanguage] = useState('');
//     const [paymentType, setPaymentType] = useState('');
//     const [sections, setSections] = useState([]);
//     const [showPopup, setShowPopup] = useState(false);
//     const [message, setMessage] = useState("");

//     const [showSectionModal, setShowSectionModal] = useState(false);
//     const [showLessonModal, setShowLessonModal] = useState(false);
//     const [newSection, setNewSection] = useState({
//         sectionTitle: '',
//         lessons: [{ title: '', video: null }]
//     });
//     const [selectedSectionIndex, setSelectedSectionIndex] = useState(null);
//     const [newLesson, setNewLesson] = useState({ title: '', video: null });

//     const instructorId = localStorage.getItem('userId');

//     const isSectionValid = () => {
//         return newSection.sectionTitle !== '' && newSection.lessons.every(lesson => lesson.title !== '' && lesson.video);
//     };

//     const isLessonValid = () => {
//         return newLesson.title !== '' && newLesson.video !== null;
//     };

//     useEffect(() => {
//         if (selectedCourse) {
//             setTitle(selectedCourse.title || '');
//             setDescription(selectedCourse.description || '');
//             setPrice(selectedCourse.price || '');
//             setLevel(selectedCourse.level || '');
//             setLanguage(selectedCourse.language || '');
//             setPaymentType(selectedCourse.paymentType || '');
//             setImagePreview(selectedCourse.imageUrl || '');
//             setCategory(selectedCourse.category || '');
//             setSubcategory(selectedCourse.subCategory || '');
//             setSections(selectedCourse.sections || []);
//         }
//     }, [selectedCourse]);

//     const handleOpenSectionModal = () => {
//         setShowSectionModal(true);
//         setNewSection({ sectionTitle: '', lessons: [{ title: '', video: null }] });
//     };

//     const handleCloseSectionModal = () => {
//         setShowSectionModal(false);
//     };

//     const handleOpenLessonModal = (sectionIndex) => {
//         setSelectedSectionIndex(sectionIndex);
//         setShowLessonModal(true);
//     };

//     const handleCloseLessonModal = () => {
//         setShowLessonModal(false);
//     };

//     const handleSectionTitleChange = (e) => {
//         setNewSection({ ...newSection, sectionTitle: e.target.value });
//     };

//     const handleLessonChange = (index, field, value) => {
//         const updatedLessons = [...newSection.lessons];
//         updatedLessons[index][field] = value;
//         setNewSection({ ...newSection, lessons: updatedLessons });
//     };

//     const handleVideoUpload = (index, event) => {
//         const file = event.target.files[0];
//         handleLessonChange(index, 'video', file);
//     };

//     const handleAddLesson = async () => {
//         toast.dismiss();
//         if (!isLessonValid()) {
//             toast.error("Please provide a lesson title and video.");
//             return;
//         }

//         const sectionId = sections[selectedSectionIndex].id;
//         const courseId = selectedCourse.courseId;

//         const formData = new FormData();
//         formData.append("instructorId", instructorId);
//         formData.append("titles", newLesson.title);
//         formData.append("videos", newLesson.video);

//         try {
//             setLoading(true);
//             const response = await addLessonToSection(courseId, sectionId, formData);


//             toast.dismiss();
//             if (response.data === "Lesson added successfully") {
//                 toast.success(response.data || "Lesson added successfully!");

//                 const updatedSections = [...sections];
//                 updatedSections[selectedSectionIndex].lessons.push(newLesson);
//                 setSections(updatedSections);

//                 setNewLesson({ title: '', video: null });
//                 handleCloseLessonModal();
//                 setTimeout(() => {
//                     window.location.reload();
//                 }, 1500);
//             } else {
//                 toast.error(response.data.data || "Failed to add lesson");
//             }
//         } catch (error) {
//             toast.dismiss();
//             if (error.response) {
//                 if (error.response.status === 500) {
//                     const errorMessage = extractLastLine(error.response.data?.data || "Internal server error.");
//                     toast.error(`${errorMessage}`);
//                 } else if (error.response.status === 400) {
//                     const errorMessage = extractLastLine(error.response.data?.data || "Invalid request data.");
//                     toast.error(`${errorMessage}`);
//                 } else {
//                     toast.error("An unexpected error occurred while processing the request.");
//                 }
//             } else {
//                 toast.error("An unknown error occurred.");
//             }
//         } finally {
//             setLoading(false);
//         }
//     };


//     const extractLastLine = (errorData) => {
//         if (typeof errorData !== 'string') {
//             return "Invalid error data format.";
//         }

//         const lines = errorData.split('\n');
//         let lastLine;
//         if (lines.some(line => line.toLowerCase().includes('video with the same name already exists'))) {
//             lastLine = lines[lines.length - 1];
//         }
//         else if (lines.some(line => line.toLowerCase().includes('video'))) {
//             lastLine = lines[lines.length - 2];
//         } else if (lines.some(line => line.toLowerCase().includes('image'))) {
//             lastLine = lines[lines.length - 3];
//         } else {
//             lastLine = lines[lines.length - 1];
//         }

//         return lastLine || "An unexpected error occurred.";
//     };

//     const handleAddSection = async () => {
//         if (!isSectionValid()) {
//             toast.error("Please provide a section title and all lesson titles and videos.");
//             return;
//         }
//         setLoading(true);
//         const formData = new FormData();

//         const sectionRequestWrapper = {
//             sectionRequests: [
//                 {
//                     title: newSection.sectionTitle,
//                     lessons: newSection.lessons.map((lesson) => ({
//                         title: lesson.title,
//                         video: lesson.video,
//                     })),
//                 },
//             ],
//         };

//         sectionRequestWrapper.sectionRequests.forEach((section, sectionIndex) => {
//             formData.append(`sectionRequests[${sectionIndex}].title`, section.title);

//             section.lessons.forEach((lesson, lessonIndex) => {
//                 formData.append(`sectionRequests[${sectionIndex}].lessons[${lessonIndex}].title`, lesson.title);
//                 if (lesson.video) {
//                     formData.append(`sectionRequests[${sectionIndex}].lessons[${lessonIndex}].video`, lesson.video);
//                 }
//             });
//         });

//         try {
//             const response = await addSectionToCourse(selectedCourse.courseId, formData, instructorId);
//             toast.dismiss();
//             if (response.data.success) {
//                 toast.success(response.data);
//                 setSections([...sections, newSection]);
//                 handleCloseSectionModal();
//                 setTimeout(() => {
//                     window.location.reload();
//                 }, 1500);
//             } else {
//                 toast.error("Failed to add section");
//             }
//         } catch (error) {
//             toast.dismiss();
//             if (error.response) {
//                 if (error.response.status === 500) {
//                     const errorMessage = extractLastLine(error.response.data?.data || "Internal server error.");
//                     toast.error(`${errorMessage}`);
//                 } else if (error.response.status === 400) {
//                     const errorMessage = extractLastLine(error.response.data?.data || "Invalid request data.");
//                     toast.error(`${errorMessage}`);
//                 } else {
//                     toast.error("An unexpected error occurred while processing the request.");
//                 }
//             } else {
//                 toast.error("An unknown error occurred.");
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = async () => {
//         setLoading(true);
//         toast.dismiss();
//         try {
//             const response = await submitCourseForApproval(selectedCourse.courseId);

//             if (response.status === 200) {
//                 toast.success("Your course has been successfully submitted. Please wait for our team to review and approve it!");
//                 setMessage("Course successfully uploaded!");
//                 closeModal();
//                 setShowPopup(true);
//                 fetchCourses();
//             }
//         } catch (error) {
//             toast.dismiss();
//             console.error("Error adding course:", error);
//             setMessage("Failed to upload course. Please try again.");
//             setShowPopup(true);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleOk = () => {
//         setShowPopup(false);
//         window.location.reload();
//     };


//     const handleDeleteLesson = async (courseId, sectionId, lessonId, instructorId) => {
//         try {
//             toast.dismiss();
//             const response = await deleteLesson(courseId, sectionId, lessonId, instructorId);

//             console.log("Delete API Response:", response);

//             if (response.data === "Lesson deleted successfully.") {
//                 toast.success(response.data || "Lesson deleted successfully!");

//                 setTimeout(() => {
//                     window.location.reload();
//                 }, 1500);
//             } else {
//                 toast.error(response || "Failed to delete lesson.");
//             }
//         } catch (error) {
//             toast.dismiss();
//             console.error("Error deleting lesson:", error);

//             if (error.response) {
//                 toast.error(error.response || "Error occurred while deleting the lesson.");
//             } else {
//                 toast.error("Network error. Please try again.");
//             }
//         }
//     };

//     const handleDeleteSection = async (courseId, sectionId) => {

//         toast.dismiss();
//         const deletingToastId = toast.success("Deleting, please wait...", { autoClose: false });

//         try {
//             await deleteSection(courseId, sectionId, instructorId);
//             toast.dismiss(deletingToastId);
//             toast.dismiss();
//             toast.success("Section deleted successfully!");

//             setSections(prevSections => prevSections.filter(section => section.id !== sectionId));

//             setTimeout(() => {
//                 window.location.reload();
//             }, 2000);

//         } catch (error) {
//             toast.dismiss();
//             toast.dismiss(deletingToastId);
//             toast.error("Error deleting section: " + error.message);
//         }
//     };

//     const handleSaveLessonTitle = async (courseId, sectionId, lessonId, newTitle, sectionIndex, lessonIndex) => {
//   try {
//     await axios.put(`${COURSES_URL}/${courseId}/sections/${sectionId}/lessons/${lessonId}`, {
//       title: newTitle,
//     });

//     const updatedSections = [...sections];
//     updatedSections[sectionIndex].lessons[lessonIndex] = {
//       ...updatedSections[sectionIndex].lessons[lessonIndex],
//       title: newTitle,
//       isEditing: false,
//       editTitle: undefined,
//     };
//     setSections(updatedSections);
//     toast.success("Lesson updated successfully");
//   } catch (error) {
//     toast.error("Failed to update lesson");
//   }
// };





//     return (
//         <div>
//             {/* <h2>Update Course</h2> */}
//             <div className="course-form-container">
//                 {loading && (
//                     <div className="loading-overlay">
//                         <div className="loading">
//                             <ClipLoader color="#F09D37" loading={true} size={70} />
//                             <p className="loading-note">Uploading videos, please wait...</p>
//                         </div>
//                     </div>
//                 )}
//                 <form>
//                     <div>
//                         <label>Course Title</label>
//                         <p>{title}</p>
//                     </div>
//                     <div>
//                         <label>Description</label>
//                         <p>{description}</p>
//                     </div>
//                     <div>
//                         <label>Price</label>
//                         <p>₹ {price}</p>
//                     </div>
//                     <div>
//                         <label>Payment Type</label>
//                         <p>{paymentType}</p>
//                     </div>
//                     <div>
//                         <label>Level</label>
//                         <p>{level}</p>
//                     </div>
//                     <div>
//                         <label>Language</label>
//                         <p>{language}</p>
//                     </div>
//                     <div>
//                         <label>Category</label>
//                         <p>{category}</p>
//                     </div>
//                     <div>
//                         <label>Subcategory</label>
//                         <p>{subcategory}</p>
//                     </div>
//                     <div>
//                         <label>Upload Thumbnail</label>
//                         {imagePreview && <img src={imagePreview} alt="Thumbnail Preview" className="uploaded-preview" />}
//                     </div>

//                     {sections.map((section, sectionIndex) => (
//                         <div key={sectionIndex} className="section-container" style={{ position: 'relative', padding: '10px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '10px' }}>
//                             <h3>Section {sectionIndex + 1}</h3>
//                             <p>Section title: {section.title}</p>

//                             <button
//                                 type="button"
//                                 onClick={() => handleDeleteSection(selectedCourse.courseId, section.id)}
//                                 style={{
//                                     position: 'absolute',
//                                     top: '10px',
//                                     right: '10px',
//                                     backgroundColor: 'red',
//                                     color: 'white',
//                                     padding: '5px 10px',
//                                     border: 'none',
//                                     borderRadius: '5px',
//                                     cursor: 'pointer',
//                                     fontSize: '12px'
//                                 }}
//                             >
//                                 Delete Section
//                             </button>

//                             {section.lessons.map((lesson, lessonIndex) => (
//                                 <div key={lessonIndex} className="lesson-container">
//                                     {lesson.isEditing ? (
//                                         <>
//                                             <input
//                                                 type="text"
//                                                 value={lesson.editTitle || lesson.title}
//                                                 onChange={(e) => {
//                                                     const updatedLessons = [...section.lessons];
//                                                     updatedLessons[lessonIndex] = {
//                                                         ...lesson,
//                                                         editTitle: e.target.value,
//                                                     };

//                                                     const updatedSections = [...sections];
//                                                     updatedSections[sectionIndex] = {
//                                                         ...section,
//                                                         lessons: updatedLessons,
//                                                     };

//                                                     setSections(updatedSections);
//                                                 }}
//                                                 style={{ padding: '6px', fontSize: '14px', marginRight: '10px' }}
//                                             />
//                                             <button
//                                                 type="button"
//                                                 onClick={() => handleSaveLessonTitle(
//                                                     selectedCourse.courseId,
//                                                     section.id,
//                                                     lesson.id,
//                                                     lesson.editTitle || lesson.title,
//                                                     sectionIndex,
//                                                     lessonIndex
//                                                 )}
//                                                 style={{
//                                                     backgroundColor: 'green',
//                                                     color: 'white',
//                                                     padding: '6px 10px',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     cursor: 'pointer',
//                                                     marginRight: '5px',
//                                                 }}
//                                             >
//                                                 Save
//                                             </button>
//                                             <button
//                                                 type="button"
//                                                 onClick={() => {
//                                                     const updatedLessons = [...section.lessons];
//                                                     updatedLessons[lessonIndex] = {
//                                                         ...lesson,
//                                                         isEditing: false,
//                                                         editTitle: undefined,
//                                                     };

//                                                     const updatedSections = [...sections];
//                                                     updatedSections[sectionIndex] = {
//                                                         ...section,
//                                                         lessons: updatedLessons,
//                                                     };

//                                                     setSections(updatedSections);
//                                                 }}
//                                                 style={{
//                                                     backgroundColor: 'gray',
//                                                     color: 'white',
//                                                     padding: '6px 10px',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     cursor: 'pointer',
//                                                 }}
//                                             >
//                                                 Cancel
//                                             </button>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <p>Lesson title: {lesson.title}</p>
//                                             {lesson.video && <p>Video: {lesson.video.name}</p>}

//                                             <button
//                                                 type="button"
//                                                 onClick={() => {
//                                                     const updatedLessons = [...section.lessons];
//                                                     updatedLessons[lessonIndex] = {
//                                                         ...lesson,
//                                                         isEditing: true,
//                                                         editTitle: lesson.title,
//                                                     };

//                                                     const updatedSections = [...sections];
//                                                     updatedSections[sectionIndex] = {
//                                                         ...section,
//                                                         lessons: updatedLessons,
//                                                     };

//                                                     setSections(updatedSections);
//                                                 }}
//                                                 style={{
//                                                     backgroundColor: 'blue',
//                                                     color: 'white',
//                                                     padding: '6px 10px',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     cursor: 'pointer',
//                                                     marginLeft: '10px',
//                                                 }}
//                                             >
//                                                 Edit
//                                             </button>

//                                             <button
//                                                 type="button"
//                                                 onClick={() =>
//                                                     handleDeleteLesson(
//                                                         selectedCourse.courseId,
//                                                         section.id,
//                                                         lesson.id,
//                                                         instructorId
//                                                     )
//                                                 }
//                                                 style={{
//                                                     backgroundColor: 'red',
//                                                     color: 'white',
//                                                     padding: '8px 12px',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     cursor: 'pointer',
//                                                     fontSize: '14px',
//                                                     marginLeft: '10px',
//                                                 }}
//                                             >
//                                                 Delete
//                                             </button>
//                                         </>
//                                     )}
//                                 </div>

//                             ))}

//                             <button
//                                 type="button"
//                                 onClick={() => handleOpenLessonModal(sectionIndex)}
//                                 style={{
//                                     backgroundColor: '#007bff',
//                                     color: 'white',
//                                     padding: '10px 15px',
//                                     border: 'none',
//                                     borderRadius: '5px',
//                                     cursor: 'pointer',
//                                     fontSize: '16px',
//                                     marginRight: '10px'
//                                 }}
//                             >
//                                 Add Lesson
//                             </button>
//                         </div>
//                     ))}



//                     <button
//                         type="button"
//                         onClick={handleOpenSectionModal}
//                         style={{
//                             backgroundColor: '#007bff',
//                             color: 'white',
//                             padding: '10px 15px',
//                             border: 'none',
//                             borderRadius: '5px',
//                             cursor: 'pointer',
//                             fontSize: '16px',
//                             marginRight: '10px'
//                         }}
//                     >
//                         Add Another Section
//                     </button>

//                     <div style={{ textAlign: "center", marginTop: "20px" }}>
//                         <button
//                             onClick={handleSubmit}
//                             disabled={loading}
//                             style={{
//                                 padding: "10px 20px",
//                                 fontSize: "16px",
//                                 backgroundColor: loading ? "#ccc" : "#007bff",
//                                 color: "#fff",
//                                 border: "none",
//                                 borderRadius: "5px",
//                                 cursor: loading ? "not-allowed" : "pointer",
//                                 transition: "background 0.3s"
//                             }}
//                         >
//                             {loading ? "Submitting..." : "Submit Course"}
//                         </button>

//                         <Modal
//                             isOpen={showPopup}
//                             onRequestClose={() => setShowPopup(false)}
//                             contentLabel="Course Submission Status"
//                             style={{
//                                 overlay: {
//                                     backgroundColor: "rgba(0, 0, 0, 0.5)",
//                                 },
//                                 content: {
//                                     width: "300px",
//                                     height: "150px",
//                                     margin: "auto",
//                                     padding: "20px",
//                                     borderRadius: "10px",
//                                     textAlign: "center",
//                                     backgroundColor: "#fff",
//                                     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)"
//                                 }
//                             }}
//                         >
//                             <h2 style={{ fontSize: "18px", marginBottom: "20px" }}>{message}</h2>
//                             <button
//                                 onClick={handleOk}
//                                 style={{
//                                     padding: "8px 16px",
//                                     fontSize: "14px",
//                                     backgroundColor: "#28a745",
//                                     color: "#fff",
//                                     border: "none",
//                                     borderRadius: "5px",
//                                     cursor: "pointer"
//                                 }}
//                             >
//                                 OK
//                             </button>
//                         </Modal>
//                     </div>

//                 </form>
//             </div>

//             {showSectionModal && (
//                 <div className="modal">
//                     <div className="modal-content">
//                         <h3>Add Section</h3>
//                         <label>Section Title:</label>
//                         <input
//                             required type="text" value={newSection.sectionTitle} onChange={handleSectionTitleChange} />

//                         <h4>Lessons</h4>
//                         {newSection.lessons.map((lesson, index) => (
//                             <div key={index}>
//                                 <label>Lesson Title:</label>
//                                 <input
//                                     required
//                                     type="text"
//                                     value={lesson.title}
//                                     onChange={(e) => handleLessonChange(index, 'title', e.target.value)}
//                                 />
//                                 <label>Upload Video:</label>
//                                 <input
//                                     required type="file" accept="video/*" onChange={(e) => handleVideoUpload(index, e)} />
//                             </div>
//                         ))}

//                         <button onClick={handleAddSection}
//                         >Save Section</button>
//                         <button onClick={handleCloseSectionModal}>Close</button>
//                     </div>
//                 </div>
//             )}

//             {showLessonModal && (
//                 <div className="modal">
//                     <div className="modal-content">
//                         <h3>Add Lesson</h3>
//                         <label>Lesson Title:</label>
//                         <input
//                             required
//                             type="text"
//                             value={newLesson.title}
//                             onChange={(e) => setNewLesson({ ...newLesson, title: e.target.value })}

//                         />
//                         <label>Upload Video:</label>
//                         <input
//                             required
//                             type="file"
//                             accept="video/*"
//                             onChange={(e) => setNewLesson({ ...newLesson, video: e.target.files[0] })}
//                         />

//                         <button onClick={handleAddLesson}>Save Lesson</button>
//                         <button onClick={handleCloseLessonModal}>Close</button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default UpdateCourse;


import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import './UpdateCourse.css';
import Modal from "react-modal";
import { addLessonToSection, addSectionToCourse, submitCourseForApproval, deleteLesson, deleteSection, COURSES_URL } from '../../Services/Services';

const UpdateCourse = ({ selectedCourse, closeModal, fetchCourses }) => {
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [category, setCategory] = useState('');
    const [subcategory, setSubcategory] = useState('');
    const [level, setLevel] = useState('');
    const [language, setLanguage] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [sections, setSections] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [message, setMessage] = useState("");

    const [showSectionModal, setShowSectionModal] = useState(false);
    const [showLessonModal, setShowLessonModal] = useState(false);
    const [newSection, setNewSection] = useState({
        sectionTitle: '',
        lessons: [{ title: '', video: null }]
    });
    const [selectedSectionIndex, setSelectedSectionIndex] = useState(null);
    const [newLesson, setNewLesson] = useState({ title: '', video: null });

    const instructorId = localStorage.getItem('userId');

    const isSectionValid = () => {
        return newSection.sectionTitle !== '' && newSection.lessons.every(lesson => lesson.title !== '' && lesson.video);
    };

    const isLessonValid = () => {
        return newLesson.title !== '' && newLesson.video !== null;
    };

    useEffect(() => {
        if (selectedCourse) {
            setTitle(selectedCourse.title || '');
            setDescription(selectedCourse.description || '');
            setPrice(selectedCourse.price || '');
            setLevel(selectedCourse.level || '');
            setLanguage(selectedCourse.language || '');
            setPaymentType(selectedCourse.paymentType || '');
            setImagePreview(selectedCourse.imageUrl || '');
            setCategory(selectedCourse.category || '');
            setSubcategory(selectedCourse.subCategory || '');
            setSections(selectedCourse.sections || []);
        }
    }, [selectedCourse]);

    const handleOpenSectionModal = () => {
        setShowSectionModal(true);
        setNewSection({ sectionTitle: '', lessons: [{ title: '', video: null }] });
    };

    const handleCloseSectionModal = () => {
        setShowSectionModal(false);
    };

    const handleOpenLessonModal = (sectionIndex) => {
        setSelectedSectionIndex(sectionIndex);
        setShowLessonModal(true);
    };

    const handleCloseLessonModal = () => {
        setShowLessonModal(false);
    };

    const handleSectionTitleChange = (e) => {
        setNewSection({ ...newSection, sectionTitle: e.target.value });
    };

    const handleLessonChange = (index, field, value) => {
        const updatedLessons = [...newSection.lessons];
        updatedLessons[index][field] = value;
        setNewSection({ ...newSection, lessons: updatedLessons });
    };

    const handleVideoUpload = (index, event) => {
        const file = event.target.files[0];
        handleLessonChange(index, 'video', file);
    };

    const handleAddLesson = async () => {
        toast.dismiss();
        if (!isLessonValid()) {
            toast.error("Please provide a lesson title and video.");
            return;
        }

        const sectionId = sections[selectedSectionIndex].id;
        const courseId = selectedCourse.courseId;

        const formData = new FormData();
        formData.append("instructorId", instructorId);
        formData.append("titles", newLesson.title);
        formData.append("videos", newLesson.video);

        try {
            setLoading(true);
            const response = await addLessonToSection(courseId, sectionId, formData);


            toast.dismiss();
            if (response.data === "Lesson added successfully") {
                toast.success(response.data || "Lesson added successfully!");

                const updatedSections = [...sections];
                updatedSections[selectedSectionIndex].lessons.push(newLesson);
                setSections(updatedSections);

                setNewLesson({ title: '', video: null });
                handleCloseLessonModal();
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                toast.error(response.data.data || "Failed to add lesson");
            }
        } catch (error) {
            toast.dismiss();
            if (error.response) {
                if (error.response.status === 500) {
                    const errorMessage = extractLastLine(error.response.data?.data || "Internal server error.");
                    toast.error(`${errorMessage}`);
                } else if (error.response.status === 400) {
                    const errorMessage = extractLastLine(error.response.data?.data || "Invalid request data.");
                    toast.error(`${errorMessage}`);
                } else {
                    toast.error("An unexpected error occurred while processing the request.");
                }
            } else {
                toast.error("An unknown error occurred.");
            }
        } finally {
            setLoading(false);
        }
    };


    const extractLastLine = (errorData) => {
        if (typeof errorData !== 'string') {
            return "Invalid error data format.";
        }

        const lines = errorData.split('\n');
        let lastLine;
        if (lines.some(line => line.toLowerCase().includes('video with the same name already exists'))) {
            lastLine = lines[lines.length - 1];
        }
        else if (lines.some(line => line.toLowerCase().includes('video'))) {
            lastLine = lines[lines.length - 2];
        } else if (lines.some(line => line.toLowerCase().includes('image'))) {
            lastLine = lines[lines.length - 3];
        } else {
            lastLine = lines[lines.length - 1];
        }

        return lastLine || "An unexpected error occurred.";
    };

    const handleAddSection = async () => {
        if (!isSectionValid()) {
            toast.error("Please provide a section title and all lesson titles and videos.");
            return;
        }
        setLoading(true);
        const formData = new FormData();

        const sectionRequestWrapper = {
            sectionRequests: [
                {
                    title: newSection.sectionTitle,
                    lessons: newSection.lessons.map((lesson) => ({
                        title: lesson.title,
                        video: lesson.video,
                    })),
                },
            ],
        };

        sectionRequestWrapper.sectionRequests.forEach((section, sectionIndex) => {
            formData.append(`sectionRequests[${sectionIndex}].title`, section.title);

            section.lessons.forEach((lesson, lessonIndex) => {
                formData.append(`sectionRequests[${sectionIndex}].lessons[${lessonIndex}].title`, lesson.title);
                if (lesson.video) {
                    formData.append(`sectionRequests[${sectionIndex}].lessons[${lessonIndex}].video`, lesson.video);
                }
            });
        });

        try {
            const response = await addSectionToCourse(selectedCourse.courseId, formData, instructorId);
            toast.dismiss();
            if (response.data.success) {
                toast.success(response.data);
                setSections([...sections, newSection]);
                handleCloseSectionModal();
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                toast.error("Failed to add section");
            }
        } catch (error) {
            toast.dismiss();
            if (error.response) {
                if (error.response.status === 500) {
                    const errorMessage = extractLastLine(error.response.data?.data || "Internal server error.");
                    toast.error(`${errorMessage}`);
                } else if (error.response.status === 400) {
                    const errorMessage = extractLastLine(error.response.data?.data || "Invalid request data.");
                    toast.error(`${errorMessage}`);
                } else {
                    toast.error("An unexpected error occurred while processing the request.");
                }
            } else {
                toast.error("An unknown error occurred.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        toast.dismiss();
        try {
            const response = await submitCourseForApproval(selectedCourse.courseId);

            if (response.status === 200) {
                toast.success("Your course has been successfully submitted. Please wait for our team to review and approve it!");
                setMessage("Course successfully uploaded!");
                closeModal();
                setShowPopup(true);
                fetchCourses();
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding course:", error);
            setMessage("Failed to upload course. Please try again.");
            setShowPopup(true);
        } finally {
            setLoading(false);
        }
    };

    const handleOk = () => {
        setShowPopup(false);
        window.location.reload();
    };


    const handleDeleteLesson = async (courseId, sectionId, lessonId, instructorId) => {
        try {
            toast.dismiss();
            const response = await deleteLesson(courseId, sectionId, lessonId, instructorId);

            console.log("Delete API Response:", response);

            if (response.data === "Lesson deleted successfully.") {
                toast.success(response.data || "Lesson deleted successfully!");

                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                toast.error(response || "Failed to delete lesson.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error deleting lesson:", error);

            if (error.response) {
                toast.error(error.response || "Error occurred while deleting the lesson.");
            } else {
                toast.error("Network error. Please try again.");
            }
        }
    };

    const handleDeleteSection = async (courseId, sectionId) => {

        toast.dismiss();
        const deletingToastId = toast.success("Deleting, please wait...", { autoClose: false });

        try {
            await deleteSection(courseId, sectionId, instructorId);
            toast.dismiss(deletingToastId);
            toast.dismiss();
            toast.success("Section deleted successfully!");

            setSections(prevSections => prevSections.filter(section => section.id !== sectionId));

            setTimeout(() => {
                window.location.reload();
            }, 2000);

        } catch (error) {
            toast.dismiss();
            toast.dismiss(deletingToastId);
            toast.error("Error deleting section: " + error.message);
        }
    };

    const handleSaveLessonTitle = async (courseId, sectionId, lessonId, newTitle, sectionIndex, lessonIndex) => {
  try {
    await axios.put(
      `${COURSES_URL}/course/${courseId}/sections/${sectionId}/lessons/${lessonId}/title?newTitle=${encodeURIComponent(newTitle)}`
    );

    const updatedSections = [...sections];
    updatedSections[sectionIndex].lessons[lessonIndex] = {
      ...updatedSections[sectionIndex].lessons[lessonIndex],
      title: newTitle,
      isEditing: false,
      editTitle: undefined,
    };
    setSections(updatedSections);
    toast.success("Lesson updated successfully");
  } catch (error) {
    toast.error("Failed to update lesson");
  }
};






    return (
        <div>
            {/* <h2>Update Course</h2> */}
            <div className="course-form-container">
                {loading && (
                    <div className="loading-overlay">
                        <div className="loading">
                            <ClipLoader color="#F09D37" loading={true} size={70} />
                            <p className="loading-note">Uploading videos, please wait...</p>
                        </div>
                    </div>
                )}
                <form>
                    <div>
                        <label>Course Title</label>
                        <p>{title}</p>
                    </div>
                    <div>
                        <label>Description</label>
                        <p>{description}</p>
                    </div>
                    <div>
                        <label>Price</label>
                        <p>₹ {price}</p>
                    </div>
                    <div>
                        <label>Payment Type</label>
                        <p>{paymentType}</p>
                    </div>
                    <div>
                        <label>Level</label>
                        <p>{level}</p>
                    </div>
                    <div>
                        <label>Language</label>
                        <p>{language}</p>
                    </div>
                    <div>
                        <label>Category</label>
                        <p>{category}</p>
                    </div>
                    <div>
                        <label>Subcategory</label>
                        <p>{subcategory}</p>
                    </div>
                    <div>
                        <label>Upload Thumbnail</label>
                        {imagePreview && <img src={imagePreview} alt="Thumbnail Preview" className="uploaded-preview" />}
                    </div>

                    {sections.map((section, sectionIndex) => (
                        <div key={sectionIndex} className="section-container" style={{ position: 'relative', padding: '10px', border: '1px solid #ddd', borderRadius: '5px', marginBottom: '10px' }}>
                            <h3>Section {sectionIndex + 1}</h3>
                            <p>Section title: {section.title}</p>

                            <button
                                type="button"
                                onClick={() => handleDeleteSection(selectedCourse.courseId, section.id)}
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    backgroundColor: 'red',
                                    color: 'white',
                                    padding: '5px 10px',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                            >
                                Delete Section
                            </button>

                            {section.lessons.map((lesson, lessonIndex) => (
                                <div key={lessonIndex} className="lesson-container">
                                    {lesson.isEditing ? (
                                        <>
                                            <input
                                                type="text"
                                                value={lesson.editTitle || lesson.title}
                                                onChange={(e) => {
                                                    const updatedLessons = [...section.lessons];
                                                    updatedLessons[lessonIndex] = {
                                                        ...lesson,
                                                        editTitle: e.target.value,
                                                    };

                                                    const updatedSections = [...sections];
                                                    updatedSections[sectionIndex] = {
                                                        ...section,
                                                        lessons: updatedLessons,
                                                    };

                                                    setSections(updatedSections);
                                                }}
                                                style={{ padding: '6px', fontSize: '14px', marginRight: '10px' }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => handleSaveLessonTitle(
                                                    selectedCourse.courseId,
                                                    section.id,
                                                    lesson.id,
                                                    lesson.editTitle || lesson.title,
                                                    sectionIndex,
                                                    lessonIndex
                                                )}
                                                style={{
                                                    backgroundColor: 'green',
                                                    color: 'white',
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                    marginRight: '5px',
                                                }}
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const updatedLessons = [...section.lessons];
                                                    updatedLessons[lessonIndex] = {
                                                        ...lesson,
                                                        isEditing: false,
                                                        editTitle: undefined,
                                                    };

                                                    const updatedSections = [...sections];
                                                    updatedSections[sectionIndex] = {
                                                        ...section,
                                                        lessons: updatedLessons,
                                                    };

                                                    setSections(updatedSections);
                                                }}
                                                style={{
                                                    backgroundColor: 'gray',
                                                    color: 'white',
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <p>Lesson title: {lesson.title}</p>
                                            {lesson.video && <p>Video: {lesson.video.name}</p>}

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const updatedLessons = [...section.lessons];
                                                    updatedLessons[lessonIndex] = {
                                                        ...lesson,
                                                        isEditing: true,
                                                        editTitle: lesson.title,
                                                    };

                                                    const updatedSections = [...sections];
                                                    updatedSections[sectionIndex] = {
                                                        ...section,
                                                        lessons: updatedLessons,
                                                    };

                                                    setSections(updatedSections);
                                                }}
                                                style={{
                                                    backgroundColor: 'blue',
                                                    color: 'white',
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                    marginLeft: '10px',
                                                }}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    handleDeleteLesson(
                                                        selectedCourse.courseId,
                                                        section.id,
                                                        lesson.id,
                                                        instructorId
                                                    )
                                                }
                                                style={{
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    padding: '8px 12px',
                                                    border: 'none',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    marginLeft: '10px',
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </>
                                    )}
                                </div>

                            ))}

                            <button
                                type="button"
                                onClick={() => handleOpenLessonModal(sectionIndex)}
                                style={{
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    padding: '10px 15px',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    marginRight: '10px'
                                }}
                            >
                                Add Lesson
                            </button>
                        </div>
                    ))}



                    <button
                        type="button"
                        onClick={handleOpenSectionModal}
                        style={{
                            backgroundColor: '#007bff',
                            color: 'white',
                            padding: '10px 15px',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            marginRight: '10px'
                        }}
                    >
                        Add Another Section
                    </button>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            style={{
                                padding: "10px 20px",
                                fontSize: "16px",
                                backgroundColor: loading ? "#ccc" : "#007bff",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: loading ? "not-allowed" : "pointer",
                                transition: "background 0.3s"
                            }}
                        >
                            {loading ? "Submitting..." : "Submit Course"}
                        </button>

                        <Modal
                            isOpen={showPopup}
                            onRequestClose={() => setShowPopup(false)}
                            contentLabel="Course Submission Status"
                            style={{
                                overlay: {
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                },
                                content: {
                                    width: "300px",
                                    height: "150px",
                                    margin: "auto",
                                    padding: "20px",
                                    borderRadius: "10px",
                                    textAlign: "center",
                                    backgroundColor: "#fff",
                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)"
                                }
                            }}
                        >
                            <h2 style={{ fontSize: "18px", marginBottom: "20px" }}>{message}</h2>
                            <button
                                onClick={handleOk}
                                style={{
                                    padding: "8px 16px",
                                    fontSize: "14px",
                                    backgroundColor: "#28a745",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer"
                                }}
                            >
                                OK
                            </button>
                        </Modal>
                    </div>

                </form>
            </div>

            {showSectionModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>Add Section</h3>
                        <label>Section Title:</label>
                        <input
                            required type="text" value={newSection.sectionTitle} onChange={handleSectionTitleChange} />

                        <h4>Lessons</h4>
                        {newSection.lessons.map((lesson, index) => (
                            <div key={index}>
                                <label>Lesson Title:</label>
                                <input
                                    required
                                    type="text"
                                    value={lesson.title}
                                    onChange={(e) => handleLessonChange(index, 'title', e.target.value)}
                                />
                                <label>Upload Video:</label>
                                <input
                                    required type="file" accept="video/*" onChange={(e) => handleVideoUpload(index, e)} />
                            </div>
                        ))}

                        <button onClick={handleAddSection}
                        >Save Section</button>
                        <button onClick={handleCloseSectionModal}>Close</button>
                    </div>
                </div>
            )}

            {showLessonModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>Add Lesson</h3>
                        <label>Lesson Title:</label>
                        <input
                            required
                            type="text"
                            value={newLesson.title}
                            onChange={(e) => setNewLesson({ ...newLesson, title: e.target.value })}

                        />
                        <label>Upload Video:</label>
                        <input
                            required
                            type="file"
                            accept="video/*"
                            onChange={(e) => setNewLesson({ ...newLesson, video: e.target.files[0] })}
                        />

                        <button onClick={handleAddLesson}>Save Lesson</button>
                        <button onClick={handleCloseLessonModal}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpdateCourse;